// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ffZXV","title":"Info_title__19x19","links":"Info_links__2d3TU","link":"Info_link__WE-0Y","logo":"Info_logo__3C9ud"};